// @ts-strict-ignore
import * as Yup from "@braze/yup-legacy";

import type { I18nT } from "@lib/dashboardI18n";
import sharedConstants from "@lib/shared_constants";

import { isAllDigits } from "./isAllDigits";

// values and codes from CountryInfo.json
const restrictedCountries = [
  { country: "Cuba", code: "CU" },
  { country: "Ukraine", code: "UA" },
  { country: "Iran", code: "IR" },
  { country: "Syria", code: "SY" },
  { country: "North Korea", code: "KP" },
  { country: "China", code: "CN" },
  { country: "Libya", code: "LY" },
];

const restrictedCountryNames = restrictedCountries.map((country) => country.country);
export const restrictedCountryCodes = restrictedCountries.map((country) => country.code);

export const phoneNumberSchema = (t: I18nT<"free-trial-registration">) =>
  Yup.string()
    .required(t("phone-number-required-status-text", "Phone number is required"))
    .max(
      sharedConstants.FREE_TRIAL.PHONE_LENGTH_LIMIT,
      t("phone-number-max-length-status-text", "Phone number must be at most {maxPhoneLength, number} digits", {
        maxPhoneLength: sharedConstants.FREE_TRIAL.PHONE_LENGTH_LIMIT,
      })
    )
    .test(
      "validPhoneNumber",
      t("phone-number-status-text", "Please enter a valid phone number"),
      (val) => val?.length > 6 && isAllDigits(val)
    );

export const phoneNumberCountryCodeSchema = (t: I18nT<"free-trial-registration">) =>
  Yup.string().test(
    "isRestrictedCountry",
    t("phone-number-country-status-text", "Unable to trial Braze in the selected country"),
    (val) => !restrictedCountryCodes.includes(val)
  );

export const countrySchema = (t: I18nT<"free-trial-registration">) =>
  Yup.string()
    .required(t("country-required-error-text", "Country is required"))
    .test(
      "isRestrictedCountry",
      t("phone-number-country-status-text", "Unable to trial Braze in the selected country"),
      (val) => !restrictedCountryNames.includes(val)
    );
